import React from "react";
import { Link } from "react-router-dom";
import SsoLoginCallBack from "Utils/SsoLoginCallBack";



const SsoCallBackNaver = () => {
    SsoLoginCallBack("naver");
    return(
        <>
        </>
    )
}

export default SsoCallBackNaver;